import { useMutation, useQuery } from '@tanstack/react-query'
import { useUserId } from '~/components/user/SessionProvider'
import { queryClient, trpc } from '~/lib/trpc'

export function useUserInboundAddress() {
  const userId = useUserId()

  return useQuery({
    ...trpc.users.getInboundAddress.queryOptions(),
    enabled: !!userId,
  })
}

export function useCreateInboundAddress() {
  return useMutation({
    ...trpc.users.createInboundAddress.mutationOptions({
      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: [['users', 'getInboundAddress']],
        })
      },
    }),
  })
}
